import styled from 'styled-components';

export const Header = styled.div`
  padding: 0 48px 0 64px;
`;

// TODO Apply it react common components
// https://fides.frontify.com/document/296206#/fonts/headline
export const Headline = styled.h1`
  color: ${(props) => props.theme.colors.black};
  font-size: 24px;
  font-weight: lighter;
  margin-bottom: 0;
`;

export const DataGridStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  h2 {
    margin-bottom: 0;
  }

  & > .ag-theme-material {
    margin-top: 0;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    .ag-tooltip {
      background-color: ${({ theme }) => theme.colors.neutral05};
      color: ${({ theme }) => theme.colors.white};
    }

    .ag-center-cols-clipper {
      min-height: auto !important;
    }

    .ag-row {
      border: none;
    }

    .grid-wrapper {
      flex: 1;
    }

    .ag-row-even {
      background-color: #eee; // TODO: This color seems to dark, so on hover is undistinguished
    }

    .statusIcon span {
      display: flex;
    }

    .signature-list {
      margin: 0;
      padding: 0;
      list-style: none;
    }

    .rightAligned {
      justify-content: flex-end;
    }

    & > div:nth-child(2) {
      flex: 1;
    }

    & > div:nth-child(1),
    & > div:nth-child(3) {
      padding: 0;
      height: 40px;
    }

    .ag-root-wrapper-body {
      margin-top: 40px;
      min-height: 500px;

      &.ag-layout-normal {
        height: auto;
      }
    }

    .grid-wrapper {
      height: 100%;
    }

    .badgePill {
      background: ${(props) => props.theme.colors.semantic.yellowWarning};
      color: ${(props) => props.theme.colors.white};
      padding: 3px 6px;
      border-radius: 3px;
    }

    .ag-header-row {
      &:first-child .ag-header-cell {
        border-top-width: 0;
      }
      .ag-header-cell {
        padding-right: 22px;
        padding-left: 10px;
      }

      .MuiIconButton-sizeSmall {
        padding: 1px;
      }
    }

    .ag-row .ag-cell {
      padding-left: 10px;
      padding-right: 10px;
      display: flex;
    }

    .ag-header-viewport {
      border-top: 1px solid ${(props) => props.theme.colors.neutral02};
    }
  }
`;

export const TooltipTitleStyled = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;

  li {
    display: inline-flex;
    vertical-align: bottom;
    align-items: center;

    .MuiSvgIcon-root {
      padding-right: 10px;
    }

    svg {
      color: ${(props) => props.theme.colors.semantic.yellowWarning};
      font-size: 30px;
    }
  }
`;
